const en: any = {
  // loader
  "loading-main": "Please wait while the data is loading...",
  // auth Header
  Individual: "Individual",
  Entity: "Entity",
  // auth footer
  phone: "telephone",
  Address: "Address",
  "All right reserved": "All rights reserved",
  slogan: "Create your future with us!",
  address_of_the_bank: "Aşgabat ş.Magtymguly şaýoly 111/2",
  // Login page
  "Sign in": "Entrance",
  "Sign up": "Register",
  "Forgot password": "Forgot your password",
  Enter: "To come in",
  Username: "Username",
  Password: "Password",
  "Invalid grand": "Incorrect username or password",

  // register page
  "success registered": "You have successfully registered",
  "user has already registered": "A user with the same name already exists",
  "email has already registered": "A user with this email already exists",
  "Is not same passwords": "Password mismatch",
  "Minimum 8 symbol": "Minimum 8 characters",
  Name: "Name",
  Surname: "Surname",
  "Phone number": "Phone number",
  Email: "Email",
  "Input email correctly": "Enter your email correctly",
  "User data": "User data",
  "Private data": "Personal data",
  "Password confirm": "Re-enter your password",
  Required: "This field is required",
  Back: "Back",
  "register disabled":
    "LEGAL ENTITIES NEED TO CONTACT THE BANK TO CONNECT TO THIS SERVICE",
  // request status
  "Successfully sent": "successfully sent",
  "filled inputs": "Completed fields",
  // room header
  "Call-center": "Information",
  Profile: "Profile",
  "Change password": "Change password",
  Logout: "Go out",
  "Are you sure to exit": "Do you want to go out?",
  // room
  Welcome: "Welcome",
  // maintable
  Type: "Type",
  Date: "Date of creation",
  inviteDate: "Invitation date",
  noInviteDate: "Not specified",
  Status: "Status",
  Action: "Action",
  "Per page": "On every page",
  Rejected: "Denied",
  Done: "Done",
  Success: "Accepted",
  Pending: "Expectation",
  Corrected: "Corrected",
  paymentPending: "Payment pending",
  correctionRequired: "Make corrections",
  // ViewItem
  Info: "Information",
  Notes: "Notes",
  "type of document": "Document type",
  "type of card": "Card type",
  "type of credit": "Loan type",
  "By who": "Applicant's name",
  "Is hurry": 'Service "Urgent"',
  "With delivery": '"Delivery" service',
  Yes: "Yes",
  No: "No",
  "Max credit amount": "Maximum loan amount",
  "Credit amount": "Amount of credit",
  "Credit percentage": "Interest rate",
  "Credit term": "Credit term",
  "Credit repayment base": "Ensuring debt repayment",
  "credit repayment sources": "Sources of debt repayment",
  "credit repayment ways": "Debt repayment methods",
  "No note": "No notes",
  invitationDate: "Invitation date and time",
  invitationNote: "Invitation note",
  correctionNote: "Correction note",
  //steps
  "Select type of card": "Select card type",
  "Input private data": "Customer data",
  "Card data": "Data for receiving a card",
  "Extra data": "Additional data",
  "Select payment type": "Select payment type",
  // private date
  "Input name correctly": "Enter your name correctly",
  "Input surname correctly": "Enter your last name correctly",
  "Input thirdname correctly": "Enter your middle name correctly",
  "Input birthdate correctly": "Enter your date of birth correctly",
  //
  Thirdname: "Surname",
  Birthdate: "date of birth",
  "Passport serie": "Passport series",
  "Passport given date": "Passport issue date",
  "Passport given place": "Place of passport issue",
  Gender: "Gender",
  Male: "Male",
  Female: "Female",
  male: "Male",
  female: "Female",
  Turkmen: "Turkmen",
  turkmen: "Turkmen",
  Other: "Other",
  Nationality: "Nationality",
  "0": "No",
  "1": "Yes",
  false: "No",
  true: "Yes",
  /////////////////////////////çard info
  "Name latin": "Name (in Latin letters)",
  "Surname latin": "Last name (in Latin letters)",
  "Input latin": "Only in Latin letters",
  "sms connection": "SMS connection service",
  "Home phone": "Home phone",
  "Birth place": "Place of Birth",
  "Code word to define":
    "Code word for your identification when contacting the bank",
  "Secret word": "A codeword",
  Note: "The note",
  "Select branch": "Select head bank or bank branch",
  Services: "Additional services",
  ourServices: "Our services",
  deliveryService: "Delivery service",
  hurryService: "Hurry service",
  Next: "Forward",
  close: "Close",
  "Card payment": "Card payment",
  "Summary payment": "Payment amount",
  "Confirm the data": "Confirm details",
  Branch: "Head bank or bank branch",
  "I confirm": "I confirm",
  Correct: "To correct",
  ////////////new Credit request
  "Credit data": "Credit details",
  "Credit calculator": "Credit calculator",
  "Select type of credit": "Select loan type",
  "year-a": "of the year",
  year: "year",
  years: "years",
  monthes: "months",
  thousand: "thousand",
  month: "month",
  "month-a": "months",
  "monthly payment": "Monthly payment",
  "Percentage payment": "Interest payment",
  "Credit payment": "Payment to repay the principal amount",
  "Need salary for credit": "At least the borrower's income amount",
  "Credit requirement": "Ensuring debt repayment",
  "credit calc notice 1":
    "The monthly payment amount is determined by the loan term",
  "credit calc notice 2":
    "The calculation was made taking into account the following: 365 days in 1 year and 30 days in 1 month on average",
  "Salary or family income": "Amount of monthly salary or family income",
  "Can input salary or family income":
    "The amount of monthly salary or family income can be entered",
  "Work position": "Job title",
  "Work experience": "Length of service since last place of work",
  "Work place": "Place of work",
  ///////////////request result/////////////
  "Success requested": "Your application has been successfully accepted",
  "Some error, try it again": "Error, please try again",
  "Notice you about website":
    'We inform you that the list of documents is posted on the official website of the Joint Stock Commercial Bank "TTBK". To go to the page',
  "follow the link": "follow this link",
  "Responsible staff": "Person responsible for you",
  "Necessary docs": "Required documents",
  successDialogNotice:
    "Your application will be reviewed by bank specialists, and you will be sent an SMS notification about the application status.",
  "Bank address": "Address of the bank",
  "Room location": "Office location",
  Floor: "Floor",
  Room: "Cabinet",
  /////////////////new document request
  "Online service payment": "Online hyzmat",
  "Is bussinessman": "Telekeçimi",
  "Select type of document": "Select document type",
  "Document data": "Data for the document",

  //////////////////EmptyData.js
  "Yuzlenme yok": "No applications",
  ////////////////////HomePhone.js
  "Input home phone correctly": "Enter your home phone number correctly",
  ///////////////////////Nationality.js
  "Input nationality correctly": "Enter your nationality correctly",
  ///////////////////////////PassportGiýenDate.js
  "Проверьте правильность даты выдачи": "Check that the issue date is correct",
  "Дата выдачи не может быть в будущем": "Issue date cannot be in the future",
  ///////////////////////PassportGivenPlace
  "Input passport given place correctly":
    "Enter the correct place in your passport",
  ////////////////////////////Passport number
  "Input passport serie correctly": "Enter the passport series correctly",
  //////////////////////////////EmailÝerify.js
  "Açary çalyşmak üçin ssylka email-e ugradyldy":
    "A link has been sent to your email to change your password.",
  "Email-i dogry giriziň": "Enter your email address correctly",
  "Açary dikeltmek": "Password reset",
  "Email dogry girizin": "Enter your email address correctly",
  Ýapmak: "Close",
  Ugratmak: "Send",
  ///////////////////////Foooter.js
  "Geljegiňizi biz bilen dörediň!": "Create the future with us!",
  ///////////////////CardInfoCheck.js
  Informations: "Information",
  "Töleg maglumatlary": "Payment Information",
  "Agree to payment policy": "I agree with the payment policy",
  ///////////////////////CardSelect.js
  "Hasaplaşyk walýutasy": "Rasset currency",
  ////////////////CreditCalc.js
  "Karzyň möhletine görä her aýdaky tölegiň möçberi kesgitlenýär":
    "The monthly payment amount is determined by the loan term",
  "1 ýylda 365 gün we ortaça 1 aýda 30 gün hasaby bilen":
    "Calculated taking into account: 365 days a year and 30 days a month",
  /////////////////////CreditInfoCheck.js
  "Karz maglumatlary": "Loan information",
  "Agree to private policy": "I agree with the privacy policy",
  //////////////////////CreditInfoSection.js
  "Not enough salary or family income": "Lack of salary or family income",
  "Not enough experience": "Not enough experience",
  ///////////////////////////////////Header
  "Home page": "Home",

  //////////////////////////////Sidebar
  "Card section": "Card department",
  "Document section": "Reference",
  "Feedback section": "Complaints and suggestions",
  "online reception": "Digital banking services",
  profile: "Profile",
  "Credit section": "Credit department",
  /////////////////////////Restore.jsx
  "Açar üstünlikli dikeldildi": "The key was successfully restored",
  "Näsazlyk, dikeltme wagty tamamlandy": "Problem, recovery time has expired",
  "Email-i dogry girizin": "Enter your email address correctly",
  "Näsazlyk, täzeden barlap görüň": "Error, please try again",
  "Gizlin açar söz gaýtalap": "Reenter password",
  "Açarlar deň gelenok": "Keys don't match",
  Dikeltmek: "Restore",
  ///////////////////////////////////pages/Room/Card
  "Kart almak üçin onlaýn ýüzlenme": "Online application for a card",
  "Ýüzlenme ugratmak": "Send a request",
  ////////////////////////pages/Room/Credit
  "Karz almak üçin onlaýn ýüzlenme": "Online application for a loan",
  //////////////////////////////////////////pages/Room/Document.jsx
  "Güwanama üçin onlaýn ýüzlenme": "Online application for a document",
  /////////////////////////////pages/Room/Profile/Offers
  "Offered cards": "Card applications",
  "Offered credits": "Loan applications",
  "Offered documents": "Applications for a document",

  //////////////////////////////pages/Room/passwordChange
  "old password": "Old Password",
  "new password": "New Password",
  "new password confirm": "New password again",
  Change: "Change",

  "easy code": "Easy password",
  "middle code": "Average password",
  "hard code": "Complex password",
  "input data is incorrect": "Incorrect data entered",
  "password successfully changed": "Password changed successfully",
  "some advices for password": "Some tips",
  "at least one uppercase":
    "Password must contain at least 1 uppercase letter (A-Z)",
  "at least one number": "Password must contain at least 1 digit (0-9)",
  "at least eight charecter": "Password must contain at least 8 characters",

  ////////////////////////////pages/Room/feedback
  "Feedback type": "Select application type",
  complain: "Complaint",
  recommend: "Offer",
  "Your text": "Your text",
  ////////////////////////////pages/Room/feedback
  "Select department": "Select department",
  "Meeting purpose": "Topic of the meeting",
  "Select your free date": "Select a date to visit the bank",
  "Meet time": "Selected date",
  /////////////////////////////////////////
  "New request": "New application",
  "Profile Edit": "Edit",
  MiddleName: "Middle name",
  ChooseRegion: "Select your bank branch",
  "Edit Profile": "Edit profile",

  "Add MoreInfo": "Add additional information",
  "Save MoreInfo": "Save additional information",
  "Save Changes": "Save changes",
  "Message from organization": "Written request from the organization",
  mary: "Mary",
  balkan: "Balkan",
  dasoguz: "Dashoguz",
  ashgabat: "Ashgabat",
  lebap: "Lebap",
  "Online Payment": "Online Payment",
  "Total Amount": "Total Amount",
  Passport: "Passport",
  "Birth date": "Birthday",
  PrivateAutoFill:
    "Your details are filled in automatically but you can change them",
  ImageChangeHelpText:
    "Click on '+' to attach a scan of your letter contacting the bank",
  ScanAreaMove: "Move the scan here",
  supportScanType: "Supported Format",
  writeYourMessage: "Enter your message",
  originNumber: "Outgoing number",
  scanDate: "Select application date",
  errorScanDate: "Проверьте правильность даты выдачи",
  helperScanText: "Прошу заполните ваши данные",
  notEntered: "Not Entered",
  dataSuccesChanged: "Data changed successfully",
  dataSuccesSaved: "Your profile data was successfully saved",
  Error: "Error",
  PleaseFillYourProfileData:
    "Please fill in additional information about your profile",
  Fill: "Fill",
  noNotifications: "You don't have any notifications yet",
  uploadMaxSizeError:
    "Ошибка. Размер файла привысил лимит в 2 мегабайт. Пожалуйста выберите файл который весит меньше 2 мегабайт",
  fileErrorTryAgain: "Error. When you try to delete a file",
  attention: "Attention",
  descriptionFillProfile:
    "We strongly recommend that you fill in your profile data for automatic completion for various actions to your personal account. You can ignore this message and click 'Continue' then you can manually fill in the data yourself without auto-filling the fields.",
  fillOutData: "Fill in details",
  continue: "Continue",
  loading: "Loading",
  faceType5: "Entity face",
  faceType1: "Individual face",
  check: "Check",
  sentAgain: "Send more",
  WeSentOnYourEmailMessage: "We sent to your email",
  MessageForEdentify: "message, confirm your identity to continue",
  YourEmailIsNotFerfied: "Your email has not been confirmed!",
  anotherEmailMessageSented: "Repeated email sent",
  emailSentVerifyError: "An error occurred while sending a repeat message",
  noVerifiedEmail: "Email confirmation required",
  verifiedEmail: "Email confirmed",
  GivenDateCantBeAFuture: "Issue date cannot be in the future",
  Add: "Add",
  youEmailSuccesVerified: "Your email has been successfully confirmed",
  errorVerifyEmail: "Email confirmation error. Please check your email",
  succesVerifyEmail:
    "Congratulations, you have successfully verified your email.",
  ForeignStudent: "About tuition payment for international students",
  PaymentForeignStudent: "International payment request",
  PaymentForeignStudentTitle: "Online request for international payments",
  selectPaymentType: "Select payment type",
  comingSoon: "Coming soon",
  "otp-send-to-your-phone": "OTP has been sent to your phone",
  "login-success": "Login successful",
  receiverInfo: "Receiver information",
  senderInfo: "Sender information",
  Patronymic: "Patronymic",
  "Surname Before Changed": "Surname Before Changed",
  "Passport Serial": "Passport Serial",
  "Passport Number": "Passport Number",
  "Passport Given Date": "Passport Given Date",
  "Passport Given Place": "Passport Given Place",
  Phone: "Phone",
  "Birth Place": "Birth Place",
  "Village / City / etc.": "Village / City / etc.",
  "House / Flat Number": "House / Flat Number",
  "Select receiver": "Select receiver",
  currency: "Currency",
  "Uploading...": "Uploading...",
  Receiver: "Receiver",
  "Change info": "Change info",
  "No receivers available": "No receivers available",
  "Add new receiver": "Add new receiver",
  "Create new receiver": "Create new receiver",
  "Edit receiver": "Edit receiver",
  "Receiver successfully created": "Receiver successfully created",
  "Failed to create receiver": "Failed to create receiver",
  "Receiver successfully updated": "Receiver successfully updated",
  "Failed to update receiver": "Failed to update receiver",
  "Only letters allowed": "Only letters allowed",
  "Minimum 3 characters": "Minimum 3 characters",
  "Maximum 50 characters": "Maximum 50 characters",
  livingAddress: "Living address",
  formalAddress: "Formal address",
  workUniver: "Full name of the university",
  Country: "Country",
  "Select country": "Country where the receiver is located",
  "Birth Date": "Birth Date",
  "Format: I-AB or II-CD": "Format: I-AŞ or II-DZ",
  "Must be exactly 6 digits": "Must be exactly 6 digits",
  "Phone format must start with + and contain only digits":
    "Номер телефона должен начинаться с + и содержать только цифры",
  "Only letters, numbers, commas, slashes, and hyphens allowed":
    "Only letters, numbers, commas, slashes, and hyphens allowed",
  // Gender: "Gender",
  // Male: "Male",
  // Female: "Female",
  // Nationality: "Nationality",
  Citizenship: "Citizenship",
  "Select citizenship": "Select citizenship",
  Cancel: "Cancel",
  "Save Receiver": "Save Receiver",
  // "Save Changes": "Save Changes",
  or: "or",
  onlyTurkmenistanCitizens:
    "At this stage, receivers must be citizens of Turkmenistan.",
  "type of payment": "type of payment",
  Amount: "Amount",
  "Visa status": "Visa status",
  "Select visa status": "Select visa status",
  VisaStudent: "Student",
  VisaTourist: "Tourist",
  VisaWork: "Work",
  Documents: "Documents",
  "Payer documents": "Payer documents",
  "Payee documents": "Payee documents",
  senderDocs:
    "Sender documents (passports (local, international), employment record book, pension certificate, employment verification letter)",
  receiverDocs:
    "Receiver documents (certificate from educational institution (if student), bank details, passports (local, international), documents confirming family relationship, residence permit)",
  "File size must be under 2MB": "File size must be under 2MB",
  "Enter valid amount": "Enter valid amount",
  "Sender Information": "Sender Information",
  "Receiver Information": "Receiver Information",
  "Payment Information": "Payment Information",
  "Surname before changed": "Surname before changed",
  "City / village": "City / village",
  "House / flat number": "House / flat number",
  "Private Information": "Private Information",
  "Passport Information": "Passport Information",
  "Work Information": "Work Information",
  Workplace: "Workplace",
  Salary: "Salary",
  "Job title": "Job title",
  "Please wait...": "Please wait",
  "Verify Code": "Verify code",
  alerts: {
    interPayment: {
      blockedByBank:
        "To use the student payment service, please have your documents verified by the relevant bank operator. After verification, you will be able to submit an online request.",
      docInactive:
        "Because your documents are outdated, please undergo verification again.",
      docExpiredOn: "The document expired on {{date}}",
      docExpirationNotSet:
        "The document’s expiration date has not been set by an administrator.",
    },
  },
  man: "Male",
  woman: "Female",
  reqDosc: "Documents (originals are required)",
  reqDocsDesc: "Description",
  reqDocsUpload: "Documents upload",
  "Choose Files": "Choose Files",
  addMoreFiles: "Add more files",
  "Replace files": "Replace files",
  uploadedFiles: "Uploaded files",
  "Already uploaded files": "Already uploaded files",
  "Selected files": "Selected files",
  "No fields required for this payment type":
    "No fields required for this payment type",
  newInterPaymentTitle: "Dear Customers!",
  newInterPaymentAlert:
    "Please be informed that if tuition fees and accommodation expenses are paid through our bank, monthly fund transfers to students are processed solely based on electronic requests.",
  newInterPaymentAlertCheck: "I have read and understood ",
  requestInfoDialog: {
    linkText: "the terms and conditions",
    text: {
      beforeLink: "I confirm",
      afterLinkBeforeAction:
        "of the agreement for this online application-survey, fully agree with it, and promise to fulfill it without reservation.",
      afterAction:
        "I guarantee that the information entered in this online application-survey was entered by me personally and that this information is accurate and not false.",
    },
    actions: {
      payment: "make the relevant payments",
      credit: "collect the documents for a loan",
      document: "print the certificate",
      card: "issue the card",
    },
    checkbox: {
      payment: "I have read the “Procedure for foreign currency exchange”",
      default: "I have read the agreement terms",
    },
  },
  additionalDocsInfoAlert: "Additional documents may be requested by the bank.",
  uploadedDataFiles: "Uploaded files and data",
  uploaded: "Uploaded",
  invalidFileType: "Invalid file type. Allowed: PDF, JPG, JPEG, PNG",
  tb: "T/b",
  attachPassport: "Attach your passport",
  personal_account_number: "Personal account number",
  prevPassportNumber: "Previous passport number",
  inputHere: "Input here",
  invalidCharacters: "Invalid characters: < > \\ ` are not allowed",
  fileExpired: "Expired",
  fileExpiredReupload: "Please re-upload",
  reuseFile: "Reuse previous file",
  expiresAt: "Expires",
  interConfirmCheckobox:
    "I confirm I personally entered the information in this online application and this information is accurate and does not contain false information.",
};
export default en;
